import type { DisplayInputProps } from '@healthnz-prm/fhir-engine-renderer/types'

const ALLOWED_IMAGE_URL_PATH = 'static.info.content.health.nz/Publicforms/FHIR'

function isAllowedImageUrl(url: string): boolean {
  return (
    url.startsWith(`https://${ALLOWED_IMAGE_URL_PATH}`) ||
    url.startsWith(`http://${ALLOWED_IMAGE_URL_PATH}`)
  )
}

export default function DisplayInput({
  category,
  label,
  labelComponent,
  media
}: DisplayInputProps) {
  if (category === 'security') {
    return (
      <div className='text-foreground rounded-md bg-yellow-50 p-3'>
        {labelComponent ?? label}
      </div>
    )
  }

  if (category === 'help') {
    return (
      // TODO: extract colors to tokens if pattern is needed in more places
      <div className='text-foreground rounded-md bg-sky-50 p-3'>
        {labelComponent ?? label}
      </div>
    )
  }

  return (
    <div>
      {media &&
        media.contentType.startsWith('image/') &&
        isAllowedImageUrl(media.url) && (
          <img
            src={media.url}
            alt={media.title ?? ''}
            className='h-auto max-w-full'
          />
        )}
      {(labelComponent || label) && (
        <div>{labelComponent ?? label}</div>
      )}
    </div>
  )
}
